(function () {
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem('wishlist')) || [];
    } catch (error) {
      console.error('Could not read wishlist:', error);
      return [];
    }
  }

  function saveWishlist(wishlist) {
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
  }

  function renderWishlistButton(button, isInWishlist) {
    if (!button) return;

    if (isInWishlist) {
      button.innerHTML = `
        <svg class="heart-filled" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.3 5.71C18.841 5.246 18.294 4.878 17.692 4.627C17.089 4.377 16.443 4.248 15.79 4.25C15.137 4.248 14.491 4.377 13.888 4.627C13.286 4.878 12.739 5.246 12.28 5.71L12 6L11.72 5.72C10.792 4.792 9.533 4.27 8.22 4.27C6.907 4.27 5.648 4.792 4.72 5.72C3.804 6.655 3.291 7.911 3.291 9.22C3.291 10.529 3.804 11.785 4.72 12.72L11.49 19.51C11.631 19.651 11.821 19.729 12.02 19.729C12.219 19.729 12.409 19.651 12.55 19.51L19.32 12.72C20.237 11.782 20.748 10.522 20.744 9.211C20.741 7.9 20.222 6.642 19.3 5.71Z" fill="#ffffff"/>
        </svg>
      `;
      button.classList.add('is-wishlisted');
      button.setAttribute('aria-label', 'Remove from wishlist');
    } else {
      button.innerHTML = `
        <svg class="heart-outline" width="30" height="30" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <rect x="0" fill="none" width="24" height="24"/>
          <g>
            <path d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z" fill="#ffffff" />
          </g>
        </svg>
      `;
      button.classList.remove('is-wishlisted');
      button.setAttribute('aria-label', 'Add to wishlist');
    }
  }

  function updateAllWishlistButtons(root) {
    const wishlist = getWishlist();
    const scope = root || document;

    scope.querySelectorAll('.wishlist_button').forEach(function (button) {
      const productId = String(button.dataset.productId);
      const isInWishlist = wishlist.some(function (item) {
        return String(item.productId) === productId;
      });

      renderWishlistButton(button, isInWishlist);
    });
  }

  function toggleWishlist(button) {
    if (!button) return;


    if (button.dataset.wishlistProcessing === 'true') return;
    button.dataset.wishlistProcessing = 'true';

    const productId = String(button.dataset.productId);
    const product = {
      productId: productId,
      productTitle: button.dataset.productTitle,
      productUrl: button.dataset.productUrl,
      productImg: button.dataset.productImage,
      productPrice: button.dataset.productPrice,
      productSubscriptionDiscount: button.dataset.subscriptionDiscount,
      productSubscriptionPrice: button.dataset.subscriptionPrice
    };

    let wishlist = getWishlist();

    const existingIndex = wishlist.findIndex(function (item) {
      return String(item.productId) === productId;
    });

    if (existingIndex === -1) {
      wishlist.push(product);
      saveWishlist(wishlist);
      renderWishlistButton(button, true);
    } else {
      wishlist.splice(existingIndex, 1);
      saveWishlist(wishlist);
      renderWishlistButton(button, false);
    }

    displayWishlist();

    requestAnimationFrame(function () {
      button.dataset.wishlistProcessing = 'false';
    });
  }

  function removeFromWishlist(productId) {
    let wishlist = getWishlist();

    wishlist = wishlist.filter(function (item) {
      return String(item.productId) !== String(productId);
    });

    saveWishlist(wishlist);
    updateAllWishlistButtons();
    displayWishlist();
  }

  function displayWishlist() {
    const wishlistData = getWishlist();
    const wishlistBlock = document.querySelector('.js-wishlistBlock');

    if (!wishlistBlock) return;

    if (wishlistData.length === 0) {
      wishlistBlock.innerHTML = `<p class="wishlist-empty">Your wishlist is empty.</p>`;
      return;
    }

    const wishlistHtml = wishlistData.map(function (item) {
      return `
        <div class="wishlist_card">
          <div class="wishlist_card_inner">
            <a class="product_image" href="${item.productUrl}">
              <img src="${item.productImg}" alt="${item.productTitle}">
            </a>
            <h3 class="product_title">
              ${item.productTitle}
            </h3>
           <div class="price_wrapper">
            <span class="product_price">One-time <span>${item.productPrice}</span></span>
            ${item.productSubscriptionPrice ? `
            <span class="product_subscription">
              Subscribe &amp; Save ${item.productSubscriptionDiscount}%  <span>${item.productSubscriptionPrice}<span>
            </span>
            ` : ''}
            </div>
            <a class="shop_now_btn" href="${item.productUrl}">Shop Now</a>
            <button class="remove_item" type="button" onclick="removeFromWishlist('${item.productId}')">
              <svg class="heart-filled" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.3 5.71C18.841 5.246 18.294 4.878 17.692 4.627C17.089 4.377 16.443 4.248 15.79 4.25C15.137 4.248 14.491 4.377 13.888 4.627C13.286 4.878 12.739 5.246 12.28 5.71L12 6L11.72 5.72C10.792 4.792 9.533 4.27 8.22 4.27C6.907 4.27 5.648 4.792 4.72 5.72C3.804 6.655 3.291 7.911 3.291 9.22C3.291 10.529 3.804 11.785 4.72 12.72L11.49 19.51C11.631 19.651 11.821 19.729 12.02 19.729C12.219 19.729 12.409 19.651 12.55 19.51L19.32 12.72C20.237 11.782 20.748 10.522 20.744 9.211C20.741 7.9 20.222 6.642 19.3 5.71Z" fill="#ffffff"/>
              </svg>
            </button>
          </div>
        </div>
      `;
    }).join('');

    wishlistBlock.innerHTML = wishlistHtml;
  }


  document.addEventListener('click', function (event) {
    const button = event.target.closest('.wishlist_button');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    toggleWishlist(button);
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    updateAllWishlistButtons();
    displayWishlist();
  });

  document.addEventListener('shopify:section:load', function () {
    updateAllWishlistButtons();
  });

  let wishlistUpdateFrame;

  const wishlistObserver = new MutationObserver(function (mutations) {
    const relevant = mutations.some(function (mutation) {
      return !(mutation.target instanceof HTMLElement) ||
        !mutation.target.closest('.wishlist_button');
    });

    if (!relevant) return;

    if (wishlistUpdateFrame) cancelAnimationFrame(wishlistUpdateFrame);

    wishlistUpdateFrame = requestAnimationFrame(function () {
      updateAllWishlistButtons();
    });
  });

  wishlistObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  window.toggleWishlist = toggleWishlist;
  window.removeFromWishlist = removeFromWishlist;
  window.displayWishlist = displayWishlist;
})();